import { createFileRoute } from '@tanstack/react-router'
import { DoctorsProfile } from '@/features/doctors/doctor-profile'

export const Route = createFileRoute('/_authenticated/doctors/$doctorId/profile')({
  component: RouteComponent,
})

function RouteComponent() {
  const { doctorId } = Route.useParams()
  return <DoctorsProfile doctorId={doctorId} activeTab="profile" />
}
